import React from 'react'
import Banner from '../components/HomePage/Banner'
import Fascilities from '../components/HomePage/Fascilities'
import Courses from '../components/HomePage/Courses'
import Achievements from '../components/HomePage/Achievements'
import TestimonialsCarousel from '../layouts/TestimonialCarousel'
import SegiPartnership from '../components/HomePage/SegiPartnership'

const HomePage = () => {
  return (
    <div>
      <Banner />
      <Fascilities />
      <SegiPartnership/>
      <Courses />
      <Achievements />
      <TestimonialsCarousel />
    </div>
  )
}

export default HomePage
